// Student record Degree Plan tab: progress, plans and one plan for the selected student
export const FETCH_STUDENT_PROGRESS = 'DP_FETCH_STUDENT_PROGRESS';
export const FETCH_STUDENT_PROGRESS_SUCCESS = 'DP_FETCH_STUDENT_PROGRESS_SUCCESS';
export const FETCH_STUDENT_PROGRESS_ERROR = 'DP_FETCH_STUDENT_PROGRESS_ERROR';
export const FETCH_STUDENT_PLANS = 'DP_FETCH_STUDENT_PLANS';
export const FETCH_STUDENT_PLANS_SUCCESS = 'DP_FETCH_STUDENT_PLANS_SUCCESS';
export const FETCH_STUDENT_PLANS_ERROR = 'DP_FETCH_STUDENT_PLANS_ERROR';
export const FETCH_STUDENT_PLAN = 'DP_FETCH_STUDENT_PLAN';
export const FETCH_STUDENT_PLAN_SUCCESS = 'DP_FETCH_STUDENT_PLAN_SUCCESS';
export const FETCH_STUDENT_PLAN_ERROR = 'DP_FETCH_STUDENT_PLAN_ERROR';
export const CLEAR_STUDENT_PLAN = 'DP_CLEAR_STUDENT_PLAN';

export const OPEN_STUDENT_PLAN = 'OPEN_STUDENT_PLAN';
